import Cookies from 'js-cookie';

const GB_DEVICE_ID_COOKIE = 'gb_device_id';

/**
 * Gets the GrowthBook device ID from the cookie set by the marketing site.
 * This does NOT create a new device ID - it only reads the existing one.
 * Returns undefined if the cookie doesn't exist.
 */
export function getGrowthBookDeviceId(): string | undefined {
  return Cookies.get(GB_DEVICE_ID_COOKIE);
}
